<template>

  <div id="reserve-opportunity-dialog" class="ui modal reserve-opportunity-modal">
    <div class="ui header">
      Estoque de Oportunidades
    </div>

    <div class="content modal-content-scrolling">
      <div v-if="$store.state.balances && $store.state.balances.length > 0" class="animated fadeIn" style="margin-top: 15px;">

        <div class="ui segment" style="padding: 20px !important;">
          <table class="ui very basic celled selectable tablet stackable table">
            <thead class="desktop-only">
              <tr>
                <th>Unidade</th>
                <th>Código</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Acondicionamento</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(balance, index) in $store.state.balances" :key="index">
                <td><strong class="mobile-only">Unidade: </strong>{{ balance.branch.name }}</td>
                <td><strong class="mobile-only">Código: </strong>{{ balance.product.code }}</td>
                <td><strong class="mobile-only">Descrição: </strong>{{ balance.product.description }}</td>
                <td><strong class="mobile-only">Quantidade: </strong>{{ $formatInteger(balance.quantity) }}</td>
                <td><strong class="mobile-only">Acondicionamento: </strong>{{ balance.address }}</td>
                <td><strong class="mobile-only">Total: </strong>{{ $formatInteger(balance.total) }}</td>
                <td v-if="balance.sent">
                  <div class="ui label">
                    <i class="check circle green icon"></i> {{ $store.state.user.isProspect ? 'Enviado' : 'Reservado' }}
                  </div>
                </td>
                <td v-else>                
                  <button v-if="$store.state.user.isProspect" class="ui mini basic left icon button" @click="showReserveDialog(balance)">
                    <i class="thumbs up blue icon"></i>
                    Tenho interesse
                  </button>
                  <button v-else class="ui mini basic left icon button" @click="showReserveDialog(balance)">
                    <i class="lock blue icon"></i>
                    Reservar
                  </button>
                </td>
              </tr>                       
            </tbody>
          </table>
        </div>

      </div>
    </div>
    <reserve-dialog ref="reserveDialog" :balance="selectedBalance" 
      :customer="selectedCustomer" :lChgCus="true" @onConfirm="onConfirm" />

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
    </div>

  </div>

</template>

<script>
  import ReserveDialog from "../pages/products/search/reserve.vue"
  import OppBalanceService from "@/services/opp-balance-service"

  export default {   
    
    data() {
      return {
        selectedBalance: null,
        selectedCustomer: null,
      }
    },
    
    components: {
      ReserveDialog,
    },

    props: ["customer"],

    mounted() {
      $("#reserve-opportunity-dialog").modal({
        autofocus: false
      })
    },

    methods: {
      show() {      
        $("#reserve-opportunity-dialog").modal("show")
      },

      hide() {
        $("#reserve-opportunity-dialog").modal("hide")
      },

      showReserveDialog(balance) {

        this.selectedBalance = balance
        this.selectedCustomer = this.customer
        this.$refs.reserveDialog.show()    
      },

      async onConfirm(data, reserveId) {
        try {
          let reserve = await OppBalanceService.searchReserves({
            reserveId: reserveId
          })

          this.$emit("onSelectReserve", reserve[0])
          this.hide()
          
        } catch (error) {
          this.$errorHandler(error)  
        }
      },



    },

    beforeDestroy() {
      $(".reserve-opportunity-modal").remove()
    },
  }

</script>

